<template>
  <div>
    <t-form ref="form" @submit.prevent>
      <div class="variant-radio-group">
        <PriceRangeRadioFormPart @result="onResult" @change="onChange" />
      </div>

      <h2 class="variant-card__title mt-8 mb-6">{{ $t('subheading') }}</h2>

      <div class="variant-radio-group">
        <DwellingTypeRadioFormPart @result="onResult" @change="onChange" />
      </div>
    </t-form>

    <FormErrorMessages :error-messages="errorMessages" />
  </div>
</template>

<script>
import AbstractFormStep from 'chimera/all/components/form/steps/AbstractFormStep'
import FormErrorMessages from 'chimera/all/components/form/FormErrorMessages'
import DwellingTypeRadioFormPart from '../../parts/dwellingType/DwellingTypeRadioFormPart.PD-10913'
import PriceRangeRadioFormPart from '../../parts/priceRange/PriceRangeRadioFormPart.PD-10913'
import NextStep from '~/pages/v2/offertes-aanvragen/je-gegevens'

export default {
  name: 'PriceRangeDwellingTypeFormStep',

  components: {
    DwellingTypeRadioFormPart,
    PriceRangeRadioFormPart,
    FormErrorMessages,
  },

  extends: AbstractFormStep,

  /**
   * @returns {{willTransitionOnValid: boolean}}
   */
  data() {
    return {
      willTransitionOnValid: true,
    }
  },

  /**
   * Pass through the submit event given from FormShell
   */
  created() {
    this.$nuxt.$on('submit', this.onSubmit)
  },

  /**
   * Clean up before component is destroyed
   */
  destroyed() {
    this.$nuxt.$off('submit', this.onSubmit)
  },

  methods: {
    /**
     * Transition
     */
    transition() {
      this.routeTo(NextStep)
    },
  },
}
</script>

<i18n>
{
  "nl-NL": {
    "subheading": "Woning"
  }
}
</i18n>
